var map = {
	"./OfficinaSans-Book.otf": 899,
	"./audiofiles/1-1.mp3": 900,
	"./audiofiles/1-10.mp3": 901,
	"./audiofiles/1-11.mp3": 902,
	"./audiofiles/1-12.mp3": 903,
	"./audiofiles/1-13.mp3": 904,
	"./audiofiles/1-14.mp3": 905,
	"./audiofiles/1-15.mp3": 906,
	"./audiofiles/1-16.mp3": 907,
	"./audiofiles/1-17.mp3": 908,
	"./audiofiles/1-18.mp3": 909,
	"./audiofiles/1-19.mp3": 910,
	"./audiofiles/1-2.mp3": 911,
	"./audiofiles/1-20.mp3": 912,
	"./audiofiles/1-3.mp3": 913,
	"./audiofiles/1-4.mp3": 914,
	"./audiofiles/1-5.mp3": 915,
	"./audiofiles/1-6.mp3": 916,
	"./audiofiles/1-7.mp3": 917,
	"./audiofiles/1-8.mp3": 918,
	"./audiofiles/1-9.mp3": 919,
	"./audiofiles/10-1.mp3": 920,
	"./audiofiles/10-10.mp3": 921,
	"./audiofiles/10-11.mp3": 922,
	"./audiofiles/10-12.mp3": 923,
	"./audiofiles/10-13.mp3": 924,
	"./audiofiles/10-14.mp3": 925,
	"./audiofiles/10-15.mp3": 926,
	"./audiofiles/10-2.mp3": 927,
	"./audiofiles/10-3.mp3": 928,
	"./audiofiles/10-4.mp3": 929,
	"./audiofiles/10-5.mp3": 930,
	"./audiofiles/10-6.mp3": 931,
	"./audiofiles/10-7.mp3": 932,
	"./audiofiles/10-8.mp3": 933,
	"./audiofiles/10-9.mp3": 934,
	"./audiofiles/11-1.mp3": 935,
	"./audiofiles/11-10.mp3": 936,
	"./audiofiles/11-2.mp3": 937,
	"./audiofiles/11-3.mp3": 938,
	"./audiofiles/11-4.mp3": 939,
	"./audiofiles/11-5.mp3": 940,
	"./audiofiles/11-6.mp3": 941,
	"./audiofiles/11-7.mp3": 942,
	"./audiofiles/11-8.mp3": 943,
	"./audiofiles/11-9.mp3": 944,
	"./audiofiles/12-1.mp3": 945,
	"./audiofiles/12-10.mp3": 946,
	"./audiofiles/12-2.mp3": 947,
	"./audiofiles/12-3.mp3": 948,
	"./audiofiles/12-4.mp3": 949,
	"./audiofiles/12-5.mp3": 950,
	"./audiofiles/12-6.mp3": 951,
	"./audiofiles/12-7.mp3": 952,
	"./audiofiles/12-8.mp3": 953,
	"./audiofiles/12-9.mp3": 954,
	"./audiofiles/13-1.mp3": 955,
	"./audiofiles/13-10.mp3": 956,
	"./audiofiles/13-11.mp3": 957,
	"./audiofiles/13-12.mp3": 958,
	"./audiofiles/13-13.mp3": 959,
	"./audiofiles/13-14.mp3": 960,
	"./audiofiles/13-15.mp3": 961,
	"./audiofiles/13-2.mp3": 962,
	"./audiofiles/13-3.mp3": 963,
	"./audiofiles/13-4.mp3": 964,
	"./audiofiles/13-5.mp3": 965,
	"./audiofiles/13-6.mp3": 966,
	"./audiofiles/13-7.mp3": 967,
	"./audiofiles/13-8.mp3": 968,
	"./audiofiles/13-9.mp3": 969,
	"./audiofiles/14-1.mp3": 970,
	"./audiofiles/14-10.mp3": 971,
	"./audiofiles/14-2.mp3": 972,
	"./audiofiles/14-3.mp3": 973,
	"./audiofiles/14-4.mp3": 974,
	"./audiofiles/14-5.mp3": 975,
	"./audiofiles/14-6.mp3": 976,
	"./audiofiles/14-7.mp3": 977,
	"./audiofiles/14-8.mp3": 978,
	"./audiofiles/14-9.mp3": 979,
	"./audiofiles/15-1.mp3": 980,
	"./audiofiles/15-10.mp3": 981,
	"./audiofiles/15-2.mp3": 982,
	"./audiofiles/15-3.mp3": 983,
	"./audiofiles/15-4.mp3": 984,
	"./audiofiles/15-5.mp3": 985,
	"./audiofiles/15-6.mp3": 986,
	"./audiofiles/15-7.mp3": 987,
	"./audiofiles/15-8.mp3": 988,
	"./audiofiles/15-9.mp3": 989,
	"./audiofiles/16-1.mp3": 990,
	"./audiofiles/16-10.mp3": 991,
	"./audiofiles/16-11.mp3": 992,
	"./audiofiles/16-12.mp3": 993,
	"./audiofiles/16-13.mp3": 994,
	"./audiofiles/16-14.mp3": 995,
	"./audiofiles/16-15.mp3": 996,
	"./audiofiles/16-16.mp3": 997,
	"./audiofiles/16-17.mp3": 998,
	"./audiofiles/16-18.mp3": 999,
	"./audiofiles/16-19.mp3": 1000,
	"./audiofiles/16-2.mp3": 1001,
	"./audiofiles/16-20.mp3": 1002,
	"./audiofiles/16-3.mp3": 1003,
	"./audiofiles/16-4.mp3": 1004,
	"./audiofiles/16-5.mp3": 1005,
	"./audiofiles/16-6.mp3": 1006,
	"./audiofiles/16-7.mp3": 1007,
	"./audiofiles/16-8.mp3": 1008,
	"./audiofiles/16-9.mp3": 1009,
	"./audiofiles/17-1.mp3": 1010,
	"./audiofiles/17-2.mp3": 1011,
	"./audiofiles/18-1.mp3": 1012,
	"./audiofiles/18-2.mp3": 1013,
	"./audiofiles/19-1.mp3": 1014,
	"./audiofiles/19-10.mp3": 1015,
	"./audiofiles/19-11.mp3": 1016,
	"./audiofiles/19-12.mp3": 1017,
	"./audiofiles/19-13.mp3": 1018,
	"./audiofiles/19-14.mp3": 1019,
	"./audiofiles/19-15.mp3": 1020,
	"./audiofiles/19-2.mp3": 1021,
	"./audiofiles/19-3.mp3": 1022,
	"./audiofiles/19-4.mp3": 1023,
	"./audiofiles/19-5.mp3": 1024,
	"./audiofiles/19-6.mp3": 1025,
	"./audiofiles/19-7.mp3": 1026,
	"./audiofiles/19-8.mp3": 1027,
	"./audiofiles/19-9.mp3": 1028,
	"./audiofiles/2-1.mp3": 1029,
	"./audiofiles/2-2.mp3": 1030,
	"./audiofiles/20-1.mp3": 1031,
	"./audiofiles/20-10.mp3": 1032,
	"./audiofiles/20-11.mp3": 1033,
	"./audiofiles/20-12.mp3": 1034,
	"./audiofiles/20-13.mp3": 1035,
	"./audiofiles/20-14.mp3": 1036,
	"./audiofiles/20-15.mp3": 1037,
	"./audiofiles/20-2.mp3": 1038,
	"./audiofiles/20-3.mp3": 1039,
	"./audiofiles/20-4.mp3": 1040,
	"./audiofiles/20-5.mp3": 1041,
	"./audiofiles/20-6.mp3": 1042,
	"./audiofiles/20-7.mp3": 1043,
	"./audiofiles/20-8.mp3": 1044,
	"./audiofiles/20-9.mp3": 1045,
	"./audiofiles/21-1.mp3": 1046,
	"./audiofiles/21-10.mp3": 1047,
	"./audiofiles/21-11.mp3": 1048,
	"./audiofiles/21-12.mp3": 1049,
	"./audiofiles/21-13.mp3": 1050,
	"./audiofiles/21-14.mp3": 1051,
	"./audiofiles/21-15.mp3": 1052,
	"./audiofiles/21-2.mp3": 1053,
	"./audiofiles/21-3.mp3": 1054,
	"./audiofiles/21-4.mp3": 1055,
	"./audiofiles/21-5.mp3": 1056,
	"./audiofiles/21-6.mp3": 1057,
	"./audiofiles/21-7.mp3": 1058,
	"./audiofiles/21-8.mp3": 1059,
	"./audiofiles/21-9.mp3": 1060,
	"./audiofiles/22-1.mp3": 1061,
	"./audiofiles/22-10.mp3": 1062,
	"./audiofiles/22-2.mp3": 1063,
	"./audiofiles/22-3.mp3": 1064,
	"./audiofiles/22-4.mp3": 1065,
	"./audiofiles/22-5.mp3": 1066,
	"./audiofiles/22-6.mp3": 1067,
	"./audiofiles/22-7.mp3": 1068,
	"./audiofiles/22-8.mp3": 1069,
	"./audiofiles/22-9.mp3": 1070,
	"./audiofiles/23-1.mp3": 1071,
	"./audiofiles/23-10.mp3": 1072,
	"./audiofiles/23-2.mp3": 1073,
	"./audiofiles/23-3.mp3": 1074,
	"./audiofiles/23-4.mp3": 1075,
	"./audiofiles/23-5.mp3": 1076,
	"./audiofiles/23-6.mp3": 1077,
	"./audiofiles/23-7.mp3": 1078,
	"./audiofiles/23-8.mp3": 1079,
	"./audiofiles/23-9.mp3": 1080,
	"./audiofiles/24-1.mp3": 1081,
	"./audiofiles/24-10.mp3": 1082,
	"./audiofiles/24-2.mp3": 1083,
	"./audiofiles/24-3.mp3": 1084,
	"./audiofiles/24-4.mp3": 1085,
	"./audiofiles/24-5.mp3": 1086,
	"./audiofiles/24-6.mp3": 1087,
	"./audiofiles/24-7.mp3": 1088,
	"./audiofiles/24-8.mp3": 1089,
	"./audiofiles/24-9.mp3": 1090,
	"./audiofiles/25-1.mp3": 1091,
	"./audiofiles/25-10.mp3": 1092,
	"./audiofiles/25-11.mp3": 1093,
	"./audiofiles/25-12.mp3": 1094,
	"./audiofiles/25-13.mp3": 1095,
	"./audiofiles/25-14.mp3": 1096,
	"./audiofiles/25-15.mp3": 1097,
	"./audiofiles/25-2.mp3": 1098,
	"./audiofiles/25-3.mp3": 1099,
	"./audiofiles/25-4.mp3": 1100,
	"./audiofiles/25-5.mp3": 1101,
	"./audiofiles/25-6.mp3": 1102,
	"./audiofiles/25-7.mp3": 1103,
	"./audiofiles/25-8.mp3": 1104,
	"./audiofiles/25-9.mp3": 1105,
	"./audiofiles/26-1.mp3": 1106,
	"./audiofiles/26-10.mp3": 1107,
	"./audiofiles/26-2.mp3": 1108,
	"./audiofiles/26-3.mp3": 1109,
	"./audiofiles/26-4.mp3": 1110,
	"./audiofiles/26-5.mp3": 1111,
	"./audiofiles/26-6.mp3": 1112,
	"./audiofiles/26-7.mp3": 1113,
	"./audiofiles/26-8.mp3": 1114,
	"./audiofiles/26-9.mp3": 1115,
	"./audiofiles/27-1.mp3": 1116,
	"./audiofiles/27-10.mp3": 1117,
	"./audiofiles/27-2.mp3": 1118,
	"./audiofiles/27-3.mp3": 1119,
	"./audiofiles/27-4.mp3": 1120,
	"./audiofiles/27-5.mp3": 1121,
	"./audiofiles/27-6.mp3": 1122,
	"./audiofiles/27-7.mp3": 1123,
	"./audiofiles/27-8.mp3": 1124,
	"./audiofiles/27-9.mp3": 1125,
	"./audiofiles/28-1.mp3": 1126,
	"./audiofiles/28-10.mp3": 1127,
	"./audiofiles/28-2.mp3": 1128,
	"./audiofiles/28-3.mp3": 1129,
	"./audiofiles/28-4.mp3": 1130,
	"./audiofiles/28-5.mp3": 1131,
	"./audiofiles/28-6.mp3": 1132,
	"./audiofiles/28-7.mp3": 1133,
	"./audiofiles/28-8.mp3": 1134,
	"./audiofiles/28-9.mp3": 1135,
	"./audiofiles/29-1.mp3": 1136,
	"./audiofiles/29-10.mp3": 1137,
	"./audiofiles/29-2.mp3": 1138,
	"./audiofiles/29-3.mp3": 1139,
	"./audiofiles/29-4.mp3": 1140,
	"./audiofiles/29-5.mp3": 1141,
	"./audiofiles/29-6.mp3": 1142,
	"./audiofiles/29-7.mp3": 1143,
	"./audiofiles/29-8.mp3": 1144,
	"./audiofiles/29-9.mp3": 1145,
	"./audiofiles/3-1.mp3": 1146,
	"./audiofiles/3-10.mp3": 1147,
	"./audiofiles/3-2.mp3": 1148,
	"./audiofiles/3-3.mp3": 1149,
	"./audiofiles/3-4.mp3": 1150,
	"./audiofiles/3-5.mp3": 1151,
	"./audiofiles/3-6.mp3": 1152,
	"./audiofiles/3-7.mp3": 1153,
	"./audiofiles/3-8.mp3": 1154,
	"./audiofiles/3-9.mp3": 1155,
	"./audiofiles/30-1.mp3": 1156,
	"./audiofiles/30-10.mp3": 1157,
	"./audiofiles/30-11.mp3": 1158,
	"./audiofiles/30-12.mp3": 1159,
	"./audiofiles/30-13.mp3": 1160,
	"./audiofiles/30-14.mp3": 1161,
	"./audiofiles/30-15.mp3": 1162,
	"./audiofiles/30-2.mp3": 1163,
	"./audiofiles/30-3.mp3": 1164,
	"./audiofiles/30-4.mp3": 1165,
	"./audiofiles/30-5.mp3": 1166,
	"./audiofiles/30-6.mp3": 1167,
	"./audiofiles/30-7.mp3": 1168,
	"./audiofiles/30-8.mp3": 1169,
	"./audiofiles/30-9.mp3": 1170,
	"./audiofiles/31-1.mp3": 1171,
	"./audiofiles/31-10.mp3": 1172,
	"./audiofiles/31-2.mp3": 1173,
	"./audiofiles/31-3.mp3": 1174,
	"./audiofiles/31-4.mp3": 1175,
	"./audiofiles/31-5.mp3": 1176,
	"./audiofiles/31-6.mp3": 1177,
	"./audiofiles/31-7.mp3": 1178,
	"./audiofiles/31-8.mp3": 1179,
	"./audiofiles/31-9.mp3": 1180,
	"./audiofiles/32-1.mp3": 1181,
	"./audiofiles/32-10.mp3": 1182,
	"./audiofiles/32-11.mp3": 1183,
	"./audiofiles/32-12.mp3": 1184,
	"./audiofiles/32-13.mp3": 1185,
	"./audiofiles/32-14.mp3": 1186,
	"./audiofiles/32-15.mp3": 1187,
	"./audiofiles/32-2.mp3": 1188,
	"./audiofiles/32-3.mp3": 1189,
	"./audiofiles/32-4.mp3": 1190,
	"./audiofiles/32-5.mp3": 1191,
	"./audiofiles/32-6.mp3": 1192,
	"./audiofiles/32-7.mp3": 1193,
	"./audiofiles/32-8.mp3": 1194,
	"./audiofiles/32-9.mp3": 1195,
	"./audiofiles/33-1.mp3": 1196,
	"./audiofiles/33-10.mp3": 1197,
	"./audiofiles/33-11.mp3": 1198,
	"./audiofiles/33-12.mp3": 1199,
	"./audiofiles/33-13.mp3": 1200,
	"./audiofiles/33-14.mp3": 1201,
	"./audiofiles/33-15.mp3": 1202,
	"./audiofiles/33-2.mp3": 1203,
	"./audiofiles/33-3.mp3": 1204,
	"./audiofiles/33-4.mp3": 1205,
	"./audiofiles/33-5.mp3": 1206,
	"./audiofiles/33-6.mp3": 1207,
	"./audiofiles/33-7.mp3": 1208,
	"./audiofiles/33-8.mp3": 1209,
	"./audiofiles/33-9.mp3": 1210,
	"./audiofiles/34-1.mp3": 1211,
	"./audiofiles/34-10.mp3": 1212,
	"./audiofiles/34-11.mp3": 1213,
	"./audiofiles/34-12.mp3": 1214,
	"./audiofiles/34-13.mp3": 1215,
	"./audiofiles/34-14.mp3": 1216,
	"./audiofiles/34-15.mp3": 1217,
	"./audiofiles/34-2.mp3": 1218,
	"./audiofiles/34-3.mp3": 1219,
	"./audiofiles/34-4.mp3": 1220,
	"./audiofiles/34-5.mp3": 1221,
	"./audiofiles/34-6.mp3": 1222,
	"./audiofiles/34-7.mp3": 1223,
	"./audiofiles/34-8.mp3": 1224,
	"./audiofiles/34-9.mp3": 1225,
	"./audiofiles/35-1.mp3": 1226,
	"./audiofiles/35-10.mp3": 1227,
	"./audiofiles/35-2.mp3": 1228,
	"./audiofiles/35-3.mp3": 1229,
	"./audiofiles/35-4.mp3": 1230,
	"./audiofiles/35-5.mp3": 1231,
	"./audiofiles/35-6.mp3": 1232,
	"./audiofiles/35-7.mp3": 1233,
	"./audiofiles/35-8.mp3": 1234,
	"./audiofiles/35-9.mp3": 1235,
	"./audiofiles/36-1.mp3": 1236,
	"./audiofiles/36-10.mp3": 1237,
	"./audiofiles/36-11.mp3": 1238,
	"./audiofiles/36-12.mp3": 1239,
	"./audiofiles/36-13.mp3": 1240,
	"./audiofiles/36-14.mp3": 1241,
	"./audiofiles/36-15.mp3": 1242,
	"./audiofiles/36-2.mp3": 1243,
	"./audiofiles/36-3.mp3": 1244,
	"./audiofiles/36-4.mp3": 1245,
	"./audiofiles/36-5.mp3": 1246,
	"./audiofiles/36-6.mp3": 1247,
	"./audiofiles/36-7.mp3": 1248,
	"./audiofiles/36-8.mp3": 1249,
	"./audiofiles/36-9.mp3": 1250,
	"./audiofiles/37-1.mp3": 1251,
	"./audiofiles/37-10.mp3": 1252,
	"./audiofiles/37-2.mp3": 1253,
	"./audiofiles/37-3.mp3": 1254,
	"./audiofiles/37-4.mp3": 1255,
	"./audiofiles/37-5.mp3": 1256,
	"./audiofiles/37-6.mp3": 1257,
	"./audiofiles/37-7.mp3": 1258,
	"./audiofiles/37-8.mp3": 1259,
	"./audiofiles/37-9.mp3": 1260,
	"./audiofiles/38-1.mp3": 1261,
	"./audiofiles/38-10.mp3": 1262,
	"./audiofiles/38-2.mp3": 1263,
	"./audiofiles/38-3.mp3": 1264,
	"./audiofiles/38-4.mp3": 1265,
	"./audiofiles/38-5.mp3": 1266,
	"./audiofiles/38-6.mp3": 1267,
	"./audiofiles/38-7.mp3": 1268,
	"./audiofiles/38-8.mp3": 1269,
	"./audiofiles/38-9.mp3": 1270,
	"./audiofiles/39-1.mp3": 1271,
	"./audiofiles/39-2.mp3": 1272,
	"./audiofiles/4-1.mp3": 1273,
	"./audiofiles/4-10.mp3": 1274,
	"./audiofiles/4-2.mp3": 1275,
	"./audiofiles/4-3.mp3": 1276,
	"./audiofiles/4-4.mp3": 1277,
	"./audiofiles/4-5.mp3": 1278,
	"./audiofiles/4-6.mp3": 1279,
	"./audiofiles/4-7.mp3": 1280,
	"./audiofiles/4-8.mp3": 1281,
	"./audiofiles/4-9.mp3": 1282,
	"./audiofiles/40-1.mp3": 1283,
	"./audiofiles/40-10.mp3": 1284,
	"./audiofiles/40-11.mp3": 1285,
	"./audiofiles/40-12.mp3": 1286,
	"./audiofiles/40-13.mp3": 1287,
	"./audiofiles/40-14.mp3": 1288,
	"./audiofiles/40-15.mp3": 1289,
	"./audiofiles/40-2.mp3": 1290,
	"./audiofiles/40-3.mp3": 1291,
	"./audiofiles/40-4.mp3": 1292,
	"./audiofiles/40-5.mp3": 1293,
	"./audiofiles/40-6.mp3": 1294,
	"./audiofiles/40-7.mp3": 1295,
	"./audiofiles/40-8.mp3": 1296,
	"./audiofiles/40-9.mp3": 1297,
	"./audiofiles/41-1.mp3": 1298,
	"./audiofiles/41-10.mp3": 1299,
	"./audiofiles/41-11.mp3": 1300,
	"./audiofiles/41-12.mp3": 1301,
	"./audiofiles/41-13.mp3": 1302,
	"./audiofiles/41-14.mp3": 1303,
	"./audiofiles/41-15.mp3": 1304,
	"./audiofiles/41-2.mp3": 1305,
	"./audiofiles/41-3.mp3": 1306,
	"./audiofiles/41-4.mp3": 1307,
	"./audiofiles/41-5.mp3": 1308,
	"./audiofiles/41-6.mp3": 1309,
	"./audiofiles/41-7.mp3": 1310,
	"./audiofiles/41-8.mp3": 1311,
	"./audiofiles/41-9.mp3": 1312,
	"./audiofiles/42-1.mp3": 1313,
	"./audiofiles/42-10.mp3": 1314,
	"./audiofiles/42-2.mp3": 1315,
	"./audiofiles/42-3.mp3": 1316,
	"./audiofiles/42-4.mp3": 1317,
	"./audiofiles/42-5.mp3": 1318,
	"./audiofiles/42-6.mp3": 1319,
	"./audiofiles/42-7.mp3": 1320,
	"./audiofiles/42-8.mp3": 1321,
	"./audiofiles/42-9.mp3": 1322,
	"./audiofiles/43-1.mp3": 1323,
	"./audiofiles/43-10.mp3": 1324,
	"./audiofiles/43-2.mp3": 1325,
	"./audiofiles/43-3.mp3": 1326,
	"./audiofiles/43-4.mp3": 1327,
	"./audiofiles/43-5.mp3": 1328,
	"./audiofiles/43-6.mp3": 1329,
	"./audiofiles/43-7.mp3": 1330,
	"./audiofiles/43-8.mp3": 1331,
	"./audiofiles/43-9.mp3": 1332,
	"./audiofiles/44-1.mp3": 1333,
	"./audiofiles/5-1.mp3": 1334,
	"./audiofiles/5-10.mp3": 1335,
	"./audiofiles/5-2.mp3": 1336,
	"./audiofiles/5-3.mp3": 1337,
	"./audiofiles/5-4.mp3": 1338,
	"./audiofiles/5-5.mp3": 1339,
	"./audiofiles/5-6.mp3": 1340,
	"./audiofiles/5-7.mp3": 1341,
	"./audiofiles/5-8.mp3": 1342,
	"./audiofiles/5-9.mp3": 1343,
	"./audiofiles/6-1.mp3": 1344,
	"./audiofiles/6-10.mp3": 1345,
	"./audiofiles/6-2.mp3": 1346,
	"./audiofiles/6-3.mp3": 1347,
	"./audiofiles/6-4.mp3": 1348,
	"./audiofiles/6-5.mp3": 1349,
	"./audiofiles/6-6.mp3": 1350,
	"./audiofiles/6-7.mp3": 1351,
	"./audiofiles/6-8.mp3": 1352,
	"./audiofiles/6-9.mp3": 1353,
	"./audiofiles/7-1.mp3": 1354,
	"./audiofiles/7-10.mp3": 1355,
	"./audiofiles/7-11.mp3": 1356,
	"./audiofiles/7-12.mp3": 1357,
	"./audiofiles/7-13.mp3": 1358,
	"./audiofiles/7-14.mp3": 1359,
	"./audiofiles/7-15.mp3": 1360,
	"./audiofiles/7-2.mp3": 1361,
	"./audiofiles/7-3.mp3": 1362,
	"./audiofiles/7-4.mp3": 1363,
	"./audiofiles/7-5.mp3": 1364,
	"./audiofiles/7-6.mp3": 1365,
	"./audiofiles/7-7.mp3": 1366,
	"./audiofiles/7-8.mp3": 1367,
	"./audiofiles/7-9.mp3": 1368,
	"./audiofiles/8-1.mp3": 1369,
	"./audiofiles/8-10.mp3": 1370,
	"./audiofiles/8-2.mp3": 1371,
	"./audiofiles/8-3.mp3": 1372,
	"./audiofiles/8-4.mp3": 1373,
	"./audiofiles/8-5.mp3": 1374,
	"./audiofiles/8-6.mp3": 1375,
	"./audiofiles/8-7.mp3": 1376,
	"./audiofiles/8-8.mp3": 1377,
	"./audiofiles/8-9.mp3": 1378,
	"./audiofiles/9-1.mp3": 1379,
	"./audiofiles/9-10.mp3": 1380,
	"./audiofiles/9-2.mp3": 1381,
	"./audiofiles/9-3.mp3": 1382,
	"./audiofiles/9-4.mp3": 1383,
	"./audiofiles/9-5.mp3": 1384,
	"./audiofiles/9-6.mp3": 1385,
	"./audiofiles/9-7.mp3": 1386,
	"./audiofiles/9-8.mp3": 1387,
	"./audiofiles/9-9.mp3": 1388,
	"./audiofiles/audioAdjustment.mp3": 1389,
	"./audiofiles/sample_Triangel.mp3": 1390,
	"./audiofilesPlus/1-1.mp3": 1391,
	"./audiofilesPlus/1-2.mp3": 1392,
	"./audiofilesPlus/1-3.mp3": 1393,
	"./audiofilesPlus/1-4.mp3": 1394,
	"./audiofilesPlus/1-5.mp3": 1395,
	"./audiofilesPlus/1-6.mp3": 1396,
	"./audiofilesPlus/10-1.mp3": 1397,
	"./audiofilesPlus/10-2.mp3": 1398,
	"./audiofilesPlus/10-3.mp3": 1399,
	"./audiofilesPlus/10-4.mp3": 1400,
	"./audiofilesPlus/10-5.mp3": 1401,
	"./audiofilesPlus/10-6.mp3": 1402,
	"./audiofilesPlus/11-1.mp3": 1403,
	"./audiofilesPlus/11-10.mp3": 1404,
	"./audiofilesPlus/11-11.mp3": 1405,
	"./audiofilesPlus/11-12.mp3": 1406,
	"./audiofilesPlus/11-13.mp3": 1407,
	"./audiofilesPlus/11-14.mp3": 1408,
	"./audiofilesPlus/11-15.mp3": 1409,
	"./audiofilesPlus/11-2.mp3": 1410,
	"./audiofilesPlus/11-3.mp3": 1411,
	"./audiofilesPlus/11-4.mp3": 1412,
	"./audiofilesPlus/11-5.mp3": 1413,
	"./audiofilesPlus/11-6.mp3": 1414,
	"./audiofilesPlus/11-7.mp3": 1415,
	"./audiofilesPlus/11-8.mp3": 1416,
	"./audiofilesPlus/11-9.mp3": 1417,
	"./audiofilesPlus/12-1.mp3": 1418,
	"./audiofilesPlus/12-10.mp3": 1419,
	"./audiofilesPlus/12-2.mp3": 1420,
	"./audiofilesPlus/12-3.mp3": 1421,
	"./audiofilesPlus/12-4.mp3": 1422,
	"./audiofilesPlus/12-5.mp3": 1423,
	"./audiofilesPlus/12-6.mp3": 1424,
	"./audiofilesPlus/12-7.mp3": 1425,
	"./audiofilesPlus/12-8.mp3": 1426,
	"./audiofilesPlus/12-9.mp3": 1427,
	"./audiofilesPlus/13-1.mp3": 1428,
	"./audiofilesPlus/13-2.mp3": 1429,
	"./audiofilesPlus/13-3.mp3": 1430,
	"./audiofilesPlus/13-4.mp3": 1431,
	"./audiofilesPlus/13-5.mp3": 1432,
	"./audiofilesPlus/13-6.mp3": 1433,
	"./audiofilesPlus/14-1.mp3": 1434,
	"./audiofilesPlus/14-10.mp3": 1435,
	"./audiofilesPlus/14-2.mp3": 1436,
	"./audiofilesPlus/14-3.mp3": 1437,
	"./audiofilesPlus/14-4.mp3": 1438,
	"./audiofilesPlus/14-5.mp3": 1439,
	"./audiofilesPlus/14-6.mp3": 1440,
	"./audiofilesPlus/14-7.mp3": 1441,
	"./audiofilesPlus/14-8.mp3": 1442,
	"./audiofilesPlus/14-9.mp3": 1443,
	"./audiofilesPlus/15-1.mp3": 1444,
	"./audiofilesPlus/15-10.mp3": 1445,
	"./audiofilesPlus/15-2.mp3": 1446,
	"./audiofilesPlus/15-3.mp3": 1447,
	"./audiofilesPlus/15-4.mp3": 1448,
	"./audiofilesPlus/15-5.mp3": 1449,
	"./audiofilesPlus/15-6.mp3": 1450,
	"./audiofilesPlus/15-7.mp3": 1451,
	"./audiofilesPlus/15-8.mp3": 1452,
	"./audiofilesPlus/15-9.mp3": 1453,
	"./audiofilesPlus/16-1.mp3": 1454,
	"./audiofilesPlus/16-10.mp3": 1455,
	"./audiofilesPlus/16-11.mp3": 1456,
	"./audiofilesPlus/16-12.mp3": 1457,
	"./audiofilesPlus/16-13.mp3": 1458,
	"./audiofilesPlus/16-14.mp3": 1459,
	"./audiofilesPlus/16-15.mp3": 1460,
	"./audiofilesPlus/16-2.mp3": 1461,
	"./audiofilesPlus/16-3.mp3": 1462,
	"./audiofilesPlus/16-4.mp3": 1463,
	"./audiofilesPlus/16-5.mp3": 1464,
	"./audiofilesPlus/16-6.mp3": 1465,
	"./audiofilesPlus/16-7.mp3": 1466,
	"./audiofilesPlus/16-8.mp3": 1467,
	"./audiofilesPlus/16-9.mp3": 1468,
	"./audiofilesPlus/17-1.mp3": 1469,
	"./audiofilesPlus/17-10.mp3": 1470,
	"./audiofilesPlus/17-2.mp3": 1471,
	"./audiofilesPlus/17-3.mp3": 1472,
	"./audiofilesPlus/17-4.mp3": 1473,
	"./audiofilesPlus/17-5.mp3": 1474,
	"./audiofilesPlus/17-6.mp3": 1475,
	"./audiofilesPlus/17-7.mp3": 1476,
	"./audiofilesPlus/17-8.mp3": 1477,
	"./audiofilesPlus/17-9.mp3": 1478,
	"./audiofilesPlus/18-1.mp3": 1479,
	"./audiofilesPlus/18-10.mp3": 1480,
	"./audiofilesPlus/18-11.mp3": 1481,
	"./audiofilesPlus/18-2.mp3": 1482,
	"./audiofilesPlus/18-3.mp3": 1483,
	"./audiofilesPlus/18-4.mp3": 1484,
	"./audiofilesPlus/18-5.mp3": 1485,
	"./audiofilesPlus/18-6.mp3": 1486,
	"./audiofilesPlus/18-7.mp3": 1487,
	"./audiofilesPlus/18-8.mp3": 1488,
	"./audiofilesPlus/18-9.mp3": 1489,
	"./audiofilesPlus/19-1.mp3": 1490,
	"./audiofilesPlus/19-10.mp3": 1491,
	"./audiofilesPlus/19-11.mp3": 1492,
	"./audiofilesPlus/19-12.mp3": 1493,
	"./audiofilesPlus/19-13.mp3": 1494,
	"./audiofilesPlus/19-14.mp3": 1495,
	"./audiofilesPlus/19-15.mp3": 1496,
	"./audiofilesPlus/19-2.mp3": 1497,
	"./audiofilesPlus/19-3.mp3": 1498,
	"./audiofilesPlus/19-4.mp3": 1499,
	"./audiofilesPlus/19-5.mp3": 1500,
	"./audiofilesPlus/19-6.mp3": 1501,
	"./audiofilesPlus/19-7.mp3": 1502,
	"./audiofilesPlus/19-8.mp3": 1503,
	"./audiofilesPlus/19-9.mp3": 1504,
	"./audiofilesPlus/2-1.mp3": 1505,
	"./audiofilesPlus/2-2.mp3": 1506,
	"./audiofilesPlus/2-3.mp3": 1507,
	"./audiofilesPlus/20-1.mp3": 1508,
	"./audiofilesPlus/20-10.mp3": 1509,
	"./audiofilesPlus/20-2.mp3": 1510,
	"./audiofilesPlus/20-3.mp3": 1511,
	"./audiofilesPlus/20-4.mp3": 1512,
	"./audiofilesPlus/20-5.mp3": 1513,
	"./audiofilesPlus/20-6.mp3": 1514,
	"./audiofilesPlus/20-7.mp3": 1515,
	"./audiofilesPlus/20-8.mp3": 1516,
	"./audiofilesPlus/20-9.mp3": 1517,
	"./audiofilesPlus/21-1.mp3": 1518,
	"./audiofilesPlus/21-10.mp3": 1519,
	"./audiofilesPlus/21-2.mp3": 1520,
	"./audiofilesPlus/21-3.mp3": 1521,
	"./audiofilesPlus/21-4.mp3": 1522,
	"./audiofilesPlus/21-5.mp3": 1523,
	"./audiofilesPlus/21-6.mp3": 1524,
	"./audiofilesPlus/21-7.mp3": 1525,
	"./audiofilesPlus/21-8.mp3": 1526,
	"./audiofilesPlus/21-9.mp3": 1527,
	"./audiofilesPlus/22-1.mp3": 1528,
	"./audiofilesPlus/22-10.mp3": 1529,
	"./audiofilesPlus/22-2.mp3": 1530,
	"./audiofilesPlus/22-3.mp3": 1531,
	"./audiofilesPlus/22-4.mp3": 1532,
	"./audiofilesPlus/22-5.mp3": 1533,
	"./audiofilesPlus/22-6.mp3": 1534,
	"./audiofilesPlus/22-7.mp3": 1535,
	"./audiofilesPlus/22-8.mp3": 1536,
	"./audiofilesPlus/22-9.mp3": 1537,
	"./audiofilesPlus/23-1.mp3": 1538,
	"./audiofilesPlus/23-10.mp3": 1539,
	"./audiofilesPlus/23-2.mp3": 1540,
	"./audiofilesPlus/23-3.mp3": 1541,
	"./audiofilesPlus/23-4.mp3": 1542,
	"./audiofilesPlus/23-5.mp3": 1543,
	"./audiofilesPlus/23-6.mp3": 1544,
	"./audiofilesPlus/23-7.mp3": 1545,
	"./audiofilesPlus/23-8.mp3": 1546,
	"./audiofilesPlus/23-9.mp3": 1547,
	"./audiofilesPlus/24-1.mp3": 1548,
	"./audiofilesPlus/24-10.mp3": 1549,
	"./audiofilesPlus/24-2.mp3": 1550,
	"./audiofilesPlus/24-3.mp3": 1551,
	"./audiofilesPlus/24-4.mp3": 1552,
	"./audiofilesPlus/24-5.mp3": 1553,
	"./audiofilesPlus/24-6.mp3": 1554,
	"./audiofilesPlus/24-7.mp3": 1555,
	"./audiofilesPlus/24-8.mp3": 1556,
	"./audiofilesPlus/24-9.mp3": 1557,
	"./audiofilesPlus/25-1.mp3": 1558,
	"./audiofilesPlus/25-2.mp3": 1559,
	"./audiofilesPlus/25-3.mp3": 1560,
	"./audiofilesPlus/25-4.mp3": 1561,
	"./audiofilesPlus/25-5.mp3": 1562,
	"./audiofilesPlus/26-1.mp3": 1563,
	"./audiofilesPlus/26-10.mp3": 1564,
	"./audiofilesPlus/26-11.mp3": 1565,
	"./audiofilesPlus/26-12.mp3": 1566,
	"./audiofilesPlus/26-13.mp3": 1567,
	"./audiofilesPlus/26-14.mp3": 1568,
	"./audiofilesPlus/26-15.mp3": 1569,
	"./audiofilesPlus/26-2.mp3": 1570,
	"./audiofilesPlus/26-3.mp3": 1571,
	"./audiofilesPlus/26-4.mp3": 1572,
	"./audiofilesPlus/26-5.mp3": 1573,
	"./audiofilesPlus/26-6.mp3": 1574,
	"./audiofilesPlus/26-7.mp3": 1575,
	"./audiofilesPlus/26-8.mp3": 1576,
	"./audiofilesPlus/26-9.mp3": 1577,
	"./audiofilesPlus/27-1.mp3": 1578,
	"./audiofilesPlus/27-10.mp3": 1579,
	"./audiofilesPlus/27-11.mp3": 1580,
	"./audiofilesPlus/27-12.mp3": 1581,
	"./audiofilesPlus/27-2.mp3": 1582,
	"./audiofilesPlus/27-3.mp3": 1583,
	"./audiofilesPlus/27-4.mp3": 1584,
	"./audiofilesPlus/27-5.mp3": 1585,
	"./audiofilesPlus/27-6.mp3": 1586,
	"./audiofilesPlus/27-7.mp3": 1587,
	"./audiofilesPlus/27-8.mp3": 1588,
	"./audiofilesPlus/27-9.mp3": 1589,
	"./audiofilesPlus/28-1.mp3": 1590,
	"./audiofilesPlus/28-10.mp3": 1591,
	"./audiofilesPlus/28-2.mp3": 1592,
	"./audiofilesPlus/28-3.mp3": 1593,
	"./audiofilesPlus/28-4.mp3": 1594,
	"./audiofilesPlus/28-5.mp3": 1595,
	"./audiofilesPlus/28-6.mp3": 1596,
	"./audiofilesPlus/28-7.mp3": 1597,
	"./audiofilesPlus/28-8.mp3": 1598,
	"./audiofilesPlus/28-9.mp3": 1599,
	"./audiofilesPlus/29-1.mp3": 1600,
	"./audiofilesPlus/29-10.mp3": 1601,
	"./audiofilesPlus/29-11.mp3": 1602,
	"./audiofilesPlus/29-12.mp3": 1603,
	"./audiofilesPlus/29-13.mp3": 1604,
	"./audiofilesPlus/29-14.mp3": 1605,
	"./audiofilesPlus/29-15.mp3": 1606,
	"./audiofilesPlus/29-2.mp3": 1607,
	"./audiofilesPlus/29-3.mp3": 1608,
	"./audiofilesPlus/29-4.mp3": 1609,
	"./audiofilesPlus/29-5.mp3": 1610,
	"./audiofilesPlus/29-6.mp3": 1611,
	"./audiofilesPlus/29-7.mp3": 1612,
	"./audiofilesPlus/29-8.mp3": 1613,
	"./audiofilesPlus/29-9.mp3": 1614,
	"./audiofilesPlus/3-1.mp3": 1615,
	"./audiofilesPlus/3-10.mp3": 1616,
	"./audiofilesPlus/3-2.mp3": 1617,
	"./audiofilesPlus/3-3.mp3": 1618,
	"./audiofilesPlus/3-4.mp3": 1619,
	"./audiofilesPlus/3-5.mp3": 1620,
	"./audiofilesPlus/3-6.mp3": 1621,
	"./audiofilesPlus/3-7.mp3": 1622,
	"./audiofilesPlus/3-8.mp3": 1623,
	"./audiofilesPlus/3-9.mp3": 1624,
	"./audiofilesPlus/30-1.mp3": 1625,
	"./audiofilesPlus/30-2.mp3": 1626,
	"./audiofilesPlus/30-3.mp3": 1627,
	"./audiofilesPlus/30-4.mp3": 1628,
	"./audiofilesPlus/30-5.mp3": 1629,
	"./audiofilesPlus/31-1.mp3": 1630,
	"./audiofilesPlus/31-10.mp3": 1631,
	"./audiofilesPlus/31-2.mp3": 1632,
	"./audiofilesPlus/31-3.mp3": 1633,
	"./audiofilesPlus/31-4.mp3": 1634,
	"./audiofilesPlus/31-5.mp3": 1635,
	"./audiofilesPlus/31-6.mp3": 1636,
	"./audiofilesPlus/31-7.mp3": 1637,
	"./audiofilesPlus/31-8.mp3": 1638,
	"./audiofilesPlus/31-9.mp3": 1639,
	"./audiofilesPlus/32-1.mp3": 1640,
	"./audiofilesPlus/33-1.mp3": 1641,
	"./audiofilesPlus/33-2.mp3": 1642,
	"./audiofilesPlus/33-3.mp3": 1643,
	"./audiofilesPlus/33_bsp.mp3": 1644,
	"./audiofilesPlus/34-1.mp3": 1645,
	"./audiofilesPlus/34-2.mp3": 1646,
	"./audiofilesPlus/34-3.mp3": 1647,
	"./audiofilesPlus/34_bsp.mp3": 1648,
	"./audiofilesPlus/35-1.mp3": 1649,
	"./audiofilesPlus/36-1.mp3": 1650,
	"./audiofilesPlus/36-10.mp3": 1651,
	"./audiofilesPlus/36-11.mp3": 1652,
	"./audiofilesPlus/36-12.mp3": 1653,
	"./audiofilesPlus/36-13.mp3": 1654,
	"./audiofilesPlus/36-14.mp3": 1655,
	"./audiofilesPlus/36-15.mp3": 1656,
	"./audiofilesPlus/36-2.mp3": 1657,
	"./audiofilesPlus/36-3.mp3": 1658,
	"./audiofilesPlus/36-4.mp3": 1659,
	"./audiofilesPlus/36-5.mp3": 1660,
	"./audiofilesPlus/36-6.mp3": 1661,
	"./audiofilesPlus/36-7.mp3": 1662,
	"./audiofilesPlus/36-8.mp3": 1663,
	"./audiofilesPlus/36-9.mp3": 1664,
	"./audiofilesPlus/37-1.mp3": 1665,
	"./audiofilesPlus/37-2.mp3": 1666,
	"./audiofilesPlus/38-1.mp3": 1667,
	"./audiofilesPlus/38-10.mp3": 1668,
	"./audiofilesPlus/38-2.mp3": 1669,
	"./audiofilesPlus/38-3.mp3": 1670,
	"./audiofilesPlus/38-4.mp3": 1671,
	"./audiofilesPlus/38-5.mp3": 1672,
	"./audiofilesPlus/38-6.mp3": 1673,
	"./audiofilesPlus/38-7.mp3": 1674,
	"./audiofilesPlus/38-8.mp3": 1675,
	"./audiofilesPlus/38-9.mp3": 1676,
	"./audiofilesPlus/39-1.mp3": 1677,
	"./audiofilesPlus/39-10.mp3": 1678,
	"./audiofilesPlus/39-2.mp3": 1679,
	"./audiofilesPlus/39-3.mp3": 1680,
	"./audiofilesPlus/39-4.mp3": 1681,
	"./audiofilesPlus/39-5.mp3": 1682,
	"./audiofilesPlus/39-6.mp3": 1683,
	"./audiofilesPlus/39-7.mp3": 1684,
	"./audiofilesPlus/39-8.mp3": 1685,
	"./audiofilesPlus/39-9.mp3": 1686,
	"./audiofilesPlus/4-2.mp3": 1687,
	"./audiofilesPlus/40-1.mp3": 1688,
	"./audiofilesPlus/5-1.mp3": 1689,
	"./audiofilesPlus/5-10.mp3": 1690,
	"./audiofilesPlus/5-2.mp3": 1691,
	"./audiofilesPlus/5-3.mp3": 1692,
	"./audiofilesPlus/5-4.mp3": 1693,
	"./audiofilesPlus/5-5.mp3": 1694,
	"./audiofilesPlus/5-6.mp3": 1695,
	"./audiofilesPlus/5-7.mp3": 1696,
	"./audiofilesPlus/5-8.mp3": 1697,
	"./audiofilesPlus/5-9.mp3": 1698,
	"./audiofilesPlus/6-1.mp3": 1699,
	"./audiofilesPlus/6-10.mp3": 1700,
	"./audiofilesPlus/6-2.mp3": 1701,
	"./audiofilesPlus/6-3.mp3": 1702,
	"./audiofilesPlus/6-4.mp3": 1703,
	"./audiofilesPlus/6-5.mp3": 1704,
	"./audiofilesPlus/6-6.mp3": 1705,
	"./audiofilesPlus/6-7.mp3": 1706,
	"./audiofilesPlus/6-8.mp3": 1707,
	"./audiofilesPlus/6-9.mp3": 1708,
	"./audiofilesPlus/7-1.mp3": 1709,
	"./audiofilesPlus/7-10.mp3": 1710,
	"./audiofilesPlus/7-2.mp3": 1711,
	"./audiofilesPlus/7-3.mp3": 1712,
	"./audiofilesPlus/7-4.mp3": 1713,
	"./audiofilesPlus/7-5.mp3": 1714,
	"./audiofilesPlus/7-6.mp3": 1715,
	"./audiofilesPlus/7-7.mp3": 1716,
	"./audiofilesPlus/7-8.mp3": 1717,
	"./audiofilesPlus/7-9.mp3": 1718,
	"./audiofilesPlus/8-1.mp3": 1719,
	"./audiofilesPlus/8-10.mp3": 1720,
	"./audiofilesPlus/8-2.mp3": 1721,
	"./audiofilesPlus/8-3.mp3": 1722,
	"./audiofilesPlus/8-4.mp3": 1723,
	"./audiofilesPlus/8-5.mp3": 1724,
	"./audiofilesPlus/8-6.mp3": 1725,
	"./audiofilesPlus/8-7.mp3": 1726,
	"./audiofilesPlus/8-8.mp3": 1727,
	"./audiofilesPlus/8-9.mp3": 1728,
	"./audiofilesPlus/9-1.mp3": 1729,
	"./audiofilesPlus/9-10.mp3": 1730,
	"./audiofilesPlus/9-11.mp3": 1731,
	"./audiofilesPlus/9-12.mp3": 1732,
	"./audiofilesPlus/9-13.mp3": 1733,
	"./audiofilesPlus/9-14.mp3": 1734,
	"./audiofilesPlus/9-15.mp3": 1735,
	"./audiofilesPlus/9-2.mp3": 1736,
	"./audiofilesPlus/9-3.mp3": 1737,
	"./audiofilesPlus/9-4.mp3": 1738,
	"./audiofilesPlus/9-5.mp3": 1739,
	"./audiofilesPlus/9-6.mp3": 1740,
	"./audiofilesPlus/9-7.mp3": 1741,
	"./audiofilesPlus/9-8.mp3": 1742,
	"./audiofilesPlus/9-9.mp3": 1743,
	"./audiofilesPlus/audioAdjustment.mp3": 1744,
	"./audiofilesPlus/c2.mp3": 1745,
	"./audiofilesPlus/optional/1-1.mp3": 1746,
	"./audiofilesPlus/optional/1-10.mp3": 1747,
	"./audiofilesPlus/optional/1-2.mp3": 1748,
	"./audiofilesPlus/optional/1-3.mp3": 1749,
	"./audiofilesPlus/optional/1-4.mp3": 1750,
	"./audiofilesPlus/optional/1-5.mp3": 1751,
	"./audiofilesPlus/optional/1-6.mp3": 1752,
	"./audiofilesPlus/optional/1-7.mp3": 1753,
	"./audiofilesPlus/optional/1-8.mp3": 1754,
	"./audiofilesPlus/optional/1-9.mp3": 1755,
	"./audiofilesPlus/optional/2-1.mp3": 1756,
	"./audiofilesPlus/optional/2-10.mp3": 1757,
	"./audiofilesPlus/optional/2-2.mp3": 1758,
	"./audiofilesPlus/optional/2-3.mp3": 1759,
	"./audiofilesPlus/optional/2-4.mp3": 1760,
	"./audiofilesPlus/optional/2-5.mp3": 1761,
	"./audiofilesPlus/optional/2-6.mp3": 1762,
	"./audiofilesPlus/optional/2-7.mp3": 1763,
	"./audiofilesPlus/optional/2-8.mp3": 1764,
	"./audiofilesPlus/optional/2-9.mp3": 1765,
	"./audiofilesPlus/optional/3-2.mp3": 1766,
	"./audiofilesPlus/optional/4-1.mp3": 1767,
	"./audiofilesPlus/optional/4-10.mp3": 1768,
	"./audiofilesPlus/optional/4-2.mp3": 1769,
	"./audiofilesPlus/optional/4-3.mp3": 1770,
	"./audiofilesPlus/optional/4-4.mp3": 1771,
	"./audiofilesPlus/optional/4-5.mp3": 1772,
	"./audiofilesPlus/optional/4-6.mp3": 1773,
	"./audiofilesPlus/optional/4-7.mp3": 1774,
	"./audiofilesPlus/optional/4-8.mp3": 1775,
	"./audiofilesPlus/optional/4-9.mp3": 1776,
	"./audiofilesPlus/optional/5-1.mp3": 1777,
	"./audiofilesPlus/optional/5-10.mp3": 1778,
	"./audiofilesPlus/optional/5-2.mp3": 1779,
	"./audiofilesPlus/optional/5-3.mp3": 1780,
	"./audiofilesPlus/optional/5-4.mp3": 1781,
	"./audiofilesPlus/optional/5-5.mp3": 1782,
	"./audiofilesPlus/optional/5-6.mp3": 1783,
	"./audiofilesPlus/optional/5-7.mp3": 1784,
	"./audiofilesPlus/optional/5-8.mp3": 1785,
	"./audiofilesPlus/optional/5-9.mp3": 1786,
	"./audiofilesPlus/optional/6-2.mp3": 1787,
	"./audiofilesPlus/optional/7-2.mp3": 1788,
	"./audiofilesPlus/optional/8-1.mp3": 1789,
	"./audiofilesPlus/optional/8-2.mp3": 1790,
	"./audiofilesPlus/optional/8-3.mp3": 1791,
	"./audiofilesPlus/optional/8-4.mp3": 1792,
	"./audiofilesPlus/optional/8-5.mp3": 1793,
	"./audiofilesPlus/optional/8_bsp.mp3": 1794,
	"./audiofilesPlus/optional/9-1.mp3": 1795,
	"./audiofilesPlus/optional/9-2.mp3": 1796,
	"./audiofilesPlus/optional/9-3.mp3": 1797,
	"./audiofilesPlus/optional/9-4.mp3": 1798,
	"./audiofilesPlus/optional/9-5.mp3": 1799,
	"./audiofilesPlus/optional/9_bsp.mp3": 1800,
	"./audiofilesPlus/optional/g_bsp.mp3": 1801,
	"./fonts/ITC-OfficinaSansITCPro-Book.eot": 1802,
	"./fonts/ITC-OfficinaSansITCPro-Book.otf": 1803,
	"./fonts/ITC-OfficinaSansITCPro-Book.svg": 1804,
	"./fonts/ITC-OfficinaSansITCPro-Book.ttf": 1805,
	"./fonts/ITC-OfficinaSansITCPro-Book.woff": 1806,
	"./fonts/ITC-OfficinaSansITCPro-Book.woff2": 1807,
	"./fonts/OfficinaSansITCPro-Bold.eot": 1808,
	"./fonts/OfficinaSansITCPro-Bold.otf": 1809,
	"./fonts/OfficinaSansITCPro-Bold.svg": 1810,
	"./fonts/OfficinaSansITCPro-Bold.ttf": 1811,
	"./fonts/OfficinaSansITCPro-Bold.woff": 1812,
	"./fonts/OfficinaSansITCPro-Bold.woff2": 1813,
	"./icons/aboutUs.svg": 296,
	"./icons/angry.svg": 297,
	"./icons/arrow-left.svg": 213,
	"./icons/arrow-right.svg": 298,
	"./icons/arrow-up.svg": 84,
	"./icons/bird.svg": 299,
	"./icons/cross.svg": 173,
	"./icons/dataProtection.svg": 300,
	"./icons/exclamation.svg": 301,
	"./icons/exercises.svg": 302,
	"./icons/externalTest.svg": 303,
	"./icons/hearingLoss.svg": 304,
	"./icons/impressum.svg": 305,
	"./icons/menu.svg": 214,
	"./icons/negativ/PA-Icon-Baby-neg.png": 215,
	"./icons/negativ/PA-Icon-Baby-neg.svg": 306,
	"./icons/negativ/PA-Icon-Fahrrad-neg_1.png": 216,
	"./icons/negativ/PA-Icon-Fahrrad-neg_1.svg": 307,
	"./icons/negativ/PA-Icon-Kirche-neg.png": 217,
	"./icons/negativ/PA-Icon-Kirche-neg.svg": 308,
	"./icons/negativ/PA-Icon-Spielplatz-neg.png": 218,
	"./icons/negativ/PA-Icon-Spielplatz-neg.svg": 309,
	"./icons/negativ/PA-Icon-Staubsauger-neg.png": 219,
	"./icons/negativ/PA-Icon-Staubsauger-neg.svg": 310,
	"./icons/negativ/PA-Icon-Stra├Яenbahn-neg.png": 220,
	"./icons/negativ/PA-Icon-Stra├Яenbahn-neg.svg": 311,
	"./icons/negativ/PA-Icon-Telefon-neg.png": 221,
	"./icons/negativ/PA-Icon-Telefon-neg.svg": 312,
	"./icons/negativ/PA-Icon-T├╝r-neg.png": 222,
	"./icons/negativ/PA-Icon-T├╝r-neg.svg": 313,
	"./icons/negativ/PA-Icon-Vogel-neg.png": 223,
	"./icons/negativ/PA-Icon-Vogel-neg.svg": 314,
	"./icons/negativ/PA-Icon-Wasserhahn-neg.png": 224,
	"./icons/negativ/PA-Icon-Wasserhahn-neg.svg": 315,
	"./icons/negativ/baby.png": 225,
	"./icons/negativ/bikeBell.png": 226,
	"./icons/negativ/birdSinging.png": 227,
	"./icons/negativ/childrenPlayground.png": 228,
	"./icons/negativ/dog.png": 229,
	"./icons/negativ/doorClosing.png": 230,
	"./icons/negativ/handMixer.png": 231,
	"./icons/negativ/hoover.png": 232,
	"./icons/negativ/organ.png": 233,
	"./icons/negativ/phone.png": 234,
	"./icons/negativ/phoneRing.png": 235,
	"./icons/negativ/policeSiren.png": 236,
	"./icons/negativ/stationSpeaker.png": 237,
	"./icons/negativ/tapWater.png": 238,
	"./icons/negativ/vaccum.png": 239,
	"./icons/negativ/waterDrops.png": 240,
	"./icons/ourProducts.svg": 316,
	"./icons/pause.svg": 241,
	"./icons/play.svg": 242,
	"./icons/positiv/PA-Icon-Baby-pos.png": 317,
	"./icons/positiv/PA-Icon-Baby-pos.svg": 318,
	"./icons/positiv/PA-Icon-Baby-pos@2x.png": 319,
	"./icons/positiv/PA-Icon-Fahrrad-neg.png": 320,
	"./icons/positiv/PA-Icon-Fahrrad-neg.svg": 321,
	"./icons/positiv/PA-Icon-Fahrrad-neg@2x.png": 322,
	"./icons/positiv/PA-Icon-Kirche-pos.png": 323,
	"./icons/positiv/PA-Icon-Kirche-pos.svg": 324,
	"./icons/positiv/PA-Icon-Kirche-pos@2x.png": 325,
	"./icons/positiv/PA-Icon-Spielplatz-pos.png": 326,
	"./icons/positiv/PA-Icon-Spielplatz-pos.svg": 327,
	"./icons/positiv/PA-Icon-Spielplatz-pos@2x.png": 328,
	"./icons/positiv/PA-Icon-Staubsauger-pos.png": 329,
	"./icons/positiv/PA-Icon-Staubsauger-pos.svg": 330,
	"./icons/positiv/PA-Icon-Staubsauger-pos@2x.png": 331,
	"./icons/positiv/PA-Icon-Stra├Яenbahn-pos.png": 332,
	"./icons/positiv/PA-Icon-Stra├Яenbahn-pos.svg": 333,
	"./icons/positiv/PA-Icon-Stra├Яenbahn-pos@2x.png": 334,
	"./icons/positiv/PA-Icon-Telefon-pos.png": 335,
	"./icons/positiv/PA-Icon-Telefon-pos.svg": 336,
	"./icons/positiv/PA-Icon-Telefon-pos@2x.png": 337,
	"./icons/positiv/PA-Icon-T├╝r-pos.png": 338,
	"./icons/positiv/PA-Icon-T├╝r-pos.svg": 339,
	"./icons/positiv/PA-Icon-T├╝r-pos@2x.png": 340,
	"./icons/positiv/PA-Icon-Vogel-pos.png": 341,
	"./icons/positiv/PA-Icon-Vogel-pos.svg": 342,
	"./icons/positiv/PA-Icon-Vogel-pos@2x.png": 343,
	"./icons/positiv/PA-Icon-Wasserhahn-pos.png": 344,
	"./icons/positiv/PA-Icon-Wasserhahn-pos.svg": 345,
	"./icons/positiv/PA-Icon-Wasserhahn-pos@2x.png": 346,
	"./icons/professionalInfo.svg": 347,
	"./icons/professionalSearch.svg": 348,
	"./icons/question.svg": 349,
	"./icons/sad.svg": 350,
	"./icons/settings.svg": 351,
	"./icons/smile.svg": 352,
	"./icons/text_size.svg": 143,
	"./icons/triangle.svg": 353,
	"./images/Board_1@2x.png": 374,
	"./images/Board_2@2x.png": 375,
	"./images/Board_3@2x.png": 376,
	"./images/Board_4@2x.png": 377,
	"./images/Board_5@2x.png": 378,
	"./images/Board_6@2x.png": 379,
	"./images/Board_7@2x.png": 380,
	"./images/HdO.jpeg": 381,
	"./images/Oval-border.svg": 256,
	"./images/Oval-filled.svg": 257,
	"./images/aboutUs1.jpg": 456,
	"./images/aboutUs2.jpg": 457,
	"./images/aboutUs3.jpg": 458,
	"./images/aboutUs4.jpg": 459,
	"./images/audio.svg": 354,
	"./images/banana/left/N1.png": 460,
	"./images/banana/left/N2.png": 461,
	"./images/banana/left/N3.png": 462,
	"./images/banana/left/N4.png": 463,
	"./images/banana/left/N5.png": 464,
	"./images/banana/left/N6.png": 465,
	"./images/banana/left/N7.png": 466,
	"./images/banana/left/S1.png": 467,
	"./images/banana/left/S2.png": 468,
	"./images/banana/left/S3.png": 469,
	"./images/banana/left/ohne.png": 243,
	"./images/banana/right/N1.png": 470,
	"./images/banana/right/N2.png": 471,
	"./images/banana/right/N3.png": 472,
	"./images/banana/right/N4.png": 473,
	"./images/banana/right/N5.png": 474,
	"./images/banana/right/N6.png": 475,
	"./images/banana/right/N7.png": 476,
	"./images/banana/right/S1.png": 477,
	"./images/banana/right/S2.png": 478,
	"./images/banana/right/S3.png": 479,
	"./images/banana/right/ohne.png": 244,
	"./images/demo_results_1.png": 382,
	"./images/demo_results_2.png": 383,
	"./images/demo_results_3.png": 384,
	"./images/ear.svg": 355,
	"./images/exercisePlus/1-1-1.png": 480,
	"./images/exercisePlus/1-1-2.png": 481,
	"./images/exercisePlus/1-1-3.png": 482,
	"./images/exercisePlus/1-1-4.png": 483,
	"./images/exercisePlus/1-2-1.png": 484,
	"./images/exercisePlus/1-2-2.png": 485,
	"./images/exercisePlus/1-2-3.png": 486,
	"./images/exercisePlus/1-2-4.png": 487,
	"./images/exercisePlus/1-3-1.png": 488,
	"./images/exercisePlus/1-3-2.png": 489,
	"./images/exercisePlus/1-3-3.png": 490,
	"./images/exercisePlus/1-3-4.png": 491,
	"./images/exercisePlus/1-4-1.png": 492,
	"./images/exercisePlus/1-4-2.png": 493,
	"./images/exercisePlus/1-4-3.png": 494,
	"./images/exercisePlus/1-4-4.png": 495,
	"./images/exercisePlus/1-5-1.png": 496,
	"./images/exercisePlus/1-5-2.png": 497,
	"./images/exercisePlus/1-5-3.png": 498,
	"./images/exercisePlus/1-5-4.png": 499,
	"./images/exercisePlus/1-6-1.png": 500,
	"./images/exercisePlus/1-6-2.png": 501,
	"./images/exercisePlus/1-6-3.png": 502,
	"./images/exercisePlus/1-6-4.png": 503,
	"./images/exercisePlus/23-1.png": 504,
	"./images/exercisePlus/23-2.png": 505,
	"./images/exercisePlus/23-3.png": 506,
	"./images/finish-exercise.svg": 356,
	"./images/flag-blue.gif": 507,
	"./images/flag-green.gif": 508,
	"./images/home.svg": 245,
	"./images/idO.jpeg": 385,
	"./images/login.svg": 246,
	"./images/logo.svg": 357,
	"./images/our_products_tmp.jpeg": 386,
	"./images/spinner.svg": 509,
	"./images/success-day.svg": 510,
	"./images/success-training.svg": 511,
	"./lang/de": 253,
	"./lang/de.json": 253,
	"./lang/en": 512,
	"./lang/en.json": 512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 898;